import Grid from '@material-ui/core/Grid'
import articlesAll from '../../utils/blog-handler/articlesAll'
import { marked } from 'marked'
import Prism from 'prismjs' 
import moment from 'moment'
import './prism-tomorrow.css'
import './Article.css'

const renderer = new marked.Renderer();

renderer.link = (href, title, text) => `<a target="_blank" href="${href}">${text}</a>`;

marked.setOptions({
	breaks: true,
	highlight: function(code){
		return Prism.highlight(code, Prism.languages.javascript, 'javascript');
	}
})

const Article = ({ data }) => {

	return (
		<section className='article'>
            <div className='article__post-info'>
            	<div className='article__post-info__header'>
	                <h3 className='article__post-info__header__title'>{data.title}</h3>
	                <div className='article__post-info__header__creation-date'>
	                    {moment(data.date).locale('es').format('LL')}
	                </div>
                </div>
                <div
                    className='article__post-info__description'
                    dangerouslySetInnerHTML={{ __html: marked(articlesAll[data.main], {renderer: renderer})}}
                />
            </div>
		</section>
	)
}

export default Article